/// <summary name='cafm.config'>Module for configuration related functionality</summary>
cafm.config = {

    containerName: "#cfgContainer",
    lookupSettingsData: null,

    targetPanel: function () {
        return $(cafm.config.containerName);
    },
    viewModel: function (config) {

        var bindTarget = cafm.config.targetPanel();

        if (config) {

            bindTarget.bindViewModel(config);
        }
        else {

            return bindTarget.getViewModel();
        }
    },
    bind: function (config) {

        var targetPanel = cafm.config.targetPanel();

        // ensure these properties are date objects and work consistently
        cafm.util.ensureDates(config.Modules.RoomBooking, ['CalendarWindowStart', 'CalendarWindowEnd']);

        cafm.config.viewModel(config);
        targetPanel.prepareForm();
        cafm.config.doCustomBind(targetPanel);

        cafm.config.setupConfigToolbar(targetPanel);

        cafm.config.sensitiseStatusOptions('EndUserBasicRole_FetchWO_LCS', 'EndUserBasicRole_DefaultFetchWO_LCS');
        cafm.config.sensitiseStatusOptions('EndUserAdvancedRoleOne_FetchWO_LCS', 'EndUserAdvancedRoleOne_DefaultFetchWO_LCS');
        cafm.config.sensitiseStatusOptions('EndUserAdvancedRoleTwo_FetchWO_LCS', 'EndUserAdvancedRoleTwo_DefaultFetchWO_LCS');
        cafm.config.sensitiseStatusOptions('HelpdeskBasic_FetchWO_LCS', 'HelpdeskBasic_DefaultFetchWO_LCS');
        cafm.config.sensitiseStatusOptions('HelpdeskAdvanced_FetchWO_LCS', 'HelpdeskAdvanced_DefaultFetchWO_LCS');
        cafm.config.sensitiseStatusOptions('Engineer_FetchWO_LCS', 'Engineer_DefaultFetchWO_LCS');
        cafm.config.sensitiseStatusOptions('Contractor_FetchWO_LCS', 'Contractor_DefaultFetchWO_LCS');

        $('.cafmTabs', targetPanel).each(function (i, el) {

            $(el).data('kendoTabStrip').select(0);
        });

        $('.cafmPb', targetPanel).each(function (i, el) {

            $('.k-link', el).first().click();
        });

        if (config.Application.Core.DocumentTypeSecurityEnabled) $('.cDocumentSecurity').show();
        if (config.Application.Core.NoteTypeSecurityEnabled) $('.cNoteSecurity').show();
        if (config.Application.Core.WidgetSecurityEnabled) $('#dashboardRoles').show();

        config = cafm.config.viewModel();

        var setCanIssueWos = function (vm, issueFieldName) {

            var canIssueName = issueFieldName.replace('WorkOrderActionIssue.WorkOrderSource', 'CanIssueWorkOrders');
            vm.set(canIssueName, vm.get(issueFieldName) != '0');
            if (!vm.get(canIssueName)) {
                vm.set(issueFieldName.replace('WorkOrderActionIssue.WorkOrderSource', 'CanUpdateSLAStartDate'), false);
            }
        },
            issueFields = [
                'Modules.HelpDesk.HelpdeskAdvancedRole.WorkOrderActionIssue.WorkOrderSource',
                'Modules.HelpDesk.HelpdeskBasicRole.WorkOrderActionIssue.WorkOrderSource',
                'Modules.Engineer.EngineerRole.WorkOrderActionIssue.WorkOrderSource',
                'Modules.Engineer.LeadEngineerRole.WorkOrderActionIssue.WorkOrderSource'
            ].forEach(function (field) { setCanIssueWos(config, field) })

        config.bind('change', function (e) {

            let vm = e.sender.source ? e.sender.source : e.sender;

            if (e.field == 'Application.Core.DocumentTypeSecurityEnabled') {

                $('.cDocumentSecurity').toggle(vm.get('Application.Core.DocumentTypeSecurityEnabled'));
            }
            if (e.field == 'Application.Core.NoteTypeSecurityEnabled') {

                $('.cNoteSecurity').toggle(vm.get('Application.Core.NoteTypeSecurityEnabled'));
            }

            if (e.field == 'Application.Core.WidgetSecurityEnabled') {

                $('#dashboardRoles').toggle(vm.get('Application.Core.WidgetSecurityEnabled'));
            }

            let pre = 'Modules.RoomBooking.';
            if ([pre + 'CalendarTextBookedBy', pre + 'CalendarTextDescription', pre + 'CalendarTextReference'].indexOf(e.field) > -1) {

                var rb = vm.Modules.RoomBooking;
                if (!(rb.CalendarTextBookedBy || rb.CalendarTextDescription || rb.CalendarTextReference)) {

                    vm.set(e.field, true);
                }
            }
            if (e.field.endsWith("IsSWOVisible") && !vm.get(e.field)) {

                var swoReqField = e.field.replace("IsSWOVisible", "IsSWORequired");
                if (vm.get(swoReqField)) vm.set(swoReqField, false)
            }

            if (e.field.endsWith('.WorkOrderActionIssue.WorkOrderSource')) {

                setCanIssueWos(vm, e.field);
            }

            let fieldValue = vm.get(e.field);
            if (e.field.endsWith('.CostCodeExactLength')) {

                let minFieldName = e.field.replace('CostCodeExactLength', 'CostCodeMinLength'),
                    maxFieldName = e.field.replace('CostCodeExactLength', 'CostCodeMaxLength'),
                    reqFieldName = e.field.replace('CostCodeExactLength', 'CostCodeRequirement'),
                    minValue = vm.get(minFieldName);

                if (fieldValue) {
                    vm.set(minFieldName, null);
                    vm.set(maxFieldName, null);
                    if (vm.get(reqFieldName) == cafm.enums.RoomBookingCostCodeRequirement.Optional)
                        vm.set(reqFieldName, cafm.enums.RoomBookingCostCodeRequirement.Required);
                }
            }
            else if (e.field.endsWith('.CostCodeMinLength') && fieldValue > 0) {

                let exactFieldName = e.field.replace('CostCodeMinLength', 'CostCodeExactLength'),
                    reqFieldName = e.field.replace('CostCodeMinLength', 'CostCodeRequirement');

                if (fieldValue) {
                    vm.set(exactFieldName, null);
                    if (vm.get(reqFieldName) == cafm.enums.RoomBookingCostCodeRequirement.Optional)
                        vm.set(reqFieldName, cafm.enums.RoomBookingCostCodeRequirement.Required);
                }
            }
            else if (e.field.endsWith('.CostCodeMaxLength') && fieldValue > 0) {

                let exactFieldName = e.field.replace('CostCodeMaxLength', 'CostCodeExactLength');

                if (fieldValue) {
                    vm.set(exactFieldName, null);
                }
            }
            else if (e.field.endsWith('.CostCodeRequirement')) {

                let exactFieldName = e.field.replace('CostCodeRequirement', 'CostCodeExactLength'),
                    minFieldName = e.field.replace('CostCodeRequirement', 'CostCodeMinLength');

                switch (parseInt(fieldValue)) {
                    case cafm.enums.RoomBookingCostCodeRequirement.Optional:
                        vm.set(exactFieldName, null);
                        vm.set(minFieldName, null);
                        break;
                }
            }
            else if (e.field.endsWith('.CreateAssetEnabled')) {
                let updateFieldName = e.field.replace('CreateAssetEnabled', 'UpdateAssetEnabled');
                vm.set(e.field.replace('CreateAssetEnabled', 'CreateOrUpdateAssetEnabled'), vm.get(updateFieldName) === true || fieldValue === true);
            }
            else if (e.field.endsWith('.UpdateAssetEnabled')) {
                let createFieldName = e.field.replace('UpdateAssetEnabled', 'CreateAssetEnabled');
                vm.set(e.field.replace('UpdateAssetEnabled', 'CreateOrUpdateAssetEnabled'), vm.get(createFieldName) === true || fieldValue === true);
            }
            else if (e.field.endsWith('Scanning.Enabled')) {
                if (fieldValue === false) {
                    vm.set(e.field.replace('.Enabled', '.AssignEnabled'), false);
                    vm.set(e.field.replace('.Enabled', '.CreateAssetEnabled'), false);
                    vm.set(e.field.replace('.Enabled', '.LogWorkOrderEnabled'), false);
                    vm.set(e.field.replace('.Enabled', '.ReassignEnabled'), false);
                    vm.set(e.field.replace('.Enabled', '.UpdateAssetEnabled'), false);
                }
            }
        });

        $('#engineerRoleTabs').find('[name$=_CriteriaLastModifiedDateFromDays]').each(function (i, el) {

            var kntb = $(el).getKendoNumericTextBox();
            $(el).closest('.fieldGroup').find('[name$=_InactiveJobsLastModifiedDateFrom]').getKendoDatePicker().enable(kntb.value() > 0);

            kntb.bind('change', function (e) {
                $(e.sender.element).closest('.fieldGroup').find('[name$=_InactiveJobsLastModifiedDateFrom]').getKendoDatePicker().enable(kntb.value() > 0);
            })
        });

        setTimeout(function () {
            $('#cfgContainer').fadeIn(cafm.views.renderTime)
        }, 250);
    },
    doCustomBind: function (parent) {
        var chkList = $('.cfChkList > ul', parent);
        chkList.each(function (i, e) {
            var ul = $(e);
            cafm.forms.listSelector.setSelected(parent, ul);
        });
        $(':checkbox', chkList).setupCheckbox();
    },
    rebind: function (selector) {

        var config = cafm.config.viewModel(), target = $(selector);
        kendo.bind(target, config);
        target.prepareForm();
        $('#dashboardRoles').toggle(config.Application.Core.WidgetSecurityEnabled);
    },
    load: function () {
        cafm.actions.execute({
            url: cafm.url.api('Configuration/GetConfiguration'),
            method: 'GET',
            cache: false,
            loaderSelector: '#main',
            loaderText: cafm.res.str.TextLoadingConfig,
            statusCodeFuncs: {
                200: function (r, s, m) {
                    cafm.config.bind(r);
                }
            }
        });
    },
    init: function () {

        if (cafm.nav.navigatable == cafm.enums.Navigatable.SiteConfiguration)
            cafm.config.load();
    },
    setupConfigToolbar: function (panel) {

        var tb = $('#cfgToolbar');
        var handle = 'cafm.config.configToolbar';
        tb.data('handler', handle).setupToolbar({});
        cafm.forms.placeMainFormToolbar();
    },
    configToolbar: {

        save: isNew => {

            var vm = cafm.config.viewModel(),
                hm = vm.Modules.HelpDesk,
                pm = vm.Modules.PropertyModule,
                em = vm.Modules.Engineer,
                cm = vm.Modules.Contractor,
                re = vm.Modules.ReportExplorer,
                rb = vm.Modules.RoomBooking;

            // format selected document types
            cafm.util.setMultipleParameterValues(hm, 'EndUserAdvancedRoleOne.PermittedDocumentTypeIDs');
            cafm.util.setMultipleParameterValues(hm, 'EndUserAdvancedRoleTwo.PermittedDocumentTypeIDs');
            cafm.util.setMultipleParameterValues(hm, 'EndUserBasicRole.PermittedDocumentTypeIDs');
            cafm.util.setMultipleParameterValues(hm, 'HelpdeskAdvancedRole.PermittedDocumentTypeIDs');
            cafm.util.setMultipleParameterValues(hm, 'HelpdeskBasicRole.PermittedDocumentTypeIDs');
            cafm.util.setMultipleParameterValues(em, 'EngineerRole.PermittedDocumentTypeIDs');
            cafm.util.setMultipleParameterValues(em, 'LeadEngineerRole.PermittedDocumentTypeIDs');
            cafm.util.setMultipleParameterValues(cm, 'ContractorRole.PermittedDocumentTypeIDs');
            cafm.util.setMultipleParameterValues(pm, 'PropertyAdvancedRole.PermittedDocumentTypeIDs');
            cafm.util.setMultipleParameterValues(pm, 'PropertyBasicRole.PermittedDocumentTypeIDs');

            // format selected note types
            cafm.util.setMultipleParameterValues(hm, 'EndUserAdvancedRoleOne.PermittedNoteTypeIDs');
            cafm.util.setMultipleParameterValues(hm, 'EndUserAdvancedRoleTwo.PermittedNoteTypeIDs');
            cafm.util.setMultipleParameterValues(hm, 'EndUserBasicRole.PermittedNoteTypeIDs');
            cafm.util.setMultipleParameterValues(hm, 'HelpdeskAdvancedRole.PermittedNoteTypeIDs');
            cafm.util.setMultipleParameterValues(hm, 'HelpdeskBasicRole.PermittedNoteTypeIDs');
            cafm.util.setMultipleParameterValues(em, 'EngineerRole.PermittedNoteTypeIDs');
            cafm.util.setMultipleParameterValues(em, 'LeadEngineerRole.PermittedNoteTypeIDs');
            cafm.util.setMultipleParameterValues(cm, 'ContractorRole.PermittedNoteTypeIDs');
            cafm.util.setMultipleParameterValues(pm, 'PropertyAdvancedRole.PermittedNoteTypeIDs');
            cafm.util.setMultipleParameterValues(pm, 'PropertyBasicRole.PermittedNoteTypeIDs');

            // format selected widget parameters
            if ($('#dashboardRoles').length) {

                cafm.util.setMultipleParameterValues(hm, 'EndUserBasicRole.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(hm, 'EndUserAdvancedRoleOne.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(hm, 'EndUserAdvancedRoleTwo.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(hm, 'HelpdeskBasicRole.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(hm, 'HelpdeskAdvancedRole.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(em, 'EngineerRole.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(em, 'LeadEngineerRole.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(cm, 'ContractorRole.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(pm, 'PropertyBasicRole.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(pm, 'PropertyAdvancedRole.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(rb, 'RoomBookingBasicRole.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(rb, 'RoomBookingAdvancedRole.PermittedWidgetIDs');
                cafm.util.setMultipleParameterValues(re, 'ReportExplorerBasicRole.PermittedWidgetIDs');
            }

            // set selected reports on each role
            cafm.config.reports.setRoleData('EndUserHelpdeskBasic', hm.EndUserBasicRole);
            cafm.config.reports.setRoleData('EndUserHelpdeskAdvanced1', hm.EndUserAdvancedRoleOne);
            cafm.config.reports.setRoleData('EndUserHelpdeskAdvanced2', hm.EndUserAdvancedRoleTwo);
            cafm.config.reports.setRoleData('HelpdeskBasic', hm.HelpdeskBasicRole);
            cafm.config.reports.setRoleData('HelpdeskAdvanced', hm.HelpdeskAdvancedRole);
            cafm.config.reports.setRoleData('Engineer', em.EngineerRole);
            cafm.config.reports.setRoleData('EngineerTeamLeader', em.LeadEngineerRole);
            cafm.config.reports.setRoleData('Contractor', cm.ContractorRole);
            cafm.config.reports.setRoleData('EndUserPropertyBasic', pm.PropertyBasicRole);
            cafm.config.reports.setRoleData('PropertyAdvanced', pm.PropertyAdvancedRole);
            cafm.config.reports.setRoleData('EndUserRoomBookingBasic', rb.RoomBookingBasicRole);
            cafm.config.reports.setRoleData('RoomBookingAdvanced', rb.RoomBookingAdvancedRole);
            cafm.config.reports.setRoleData('ReportExplorerBasic', re.ReportExplorerBasicRole);

            cafm.actions.execute({
                url: cafm.url.api('Configuration/SaveConfiguration') + (isNew === true ? '?isNew=true' : ''),
                values: vm,
                elementId: 'cfgContainer',
                showMessageInWindow: true,
                confirmationPromptMessage: isNew === true ? cafm.res.str.MessageAreYouSureYouWantToCreateNewConfiguration : '',
                loaderSelector: '#main,#sub-header-toolbar [data-key="Save"]',
                validate: function (a) {

                    var vm = a.get('values');
                    var visibleLocalityLevel = parseInt(vm.get('Application.Core.VisibleLocationLevel'));
                    var hdMinLocalityLevel = parseInt(vm.get('Modules.HelpDesk.MinimumLocationLevel'));

                    var engMinLocalityLevel = parseInt(vm.get('Modules.Engineer.MinimumLocationLevel'));
                    var contMinLocalityLevel = parseInt(vm.get('Modules.Contractor.MinimumLocationLevel'));

                    var propDataIssueEnabled = vm.get('Modules.PropertyModule.PropertyInformationError.Enabled');
                    var issueEmail = vm.get('Modules.PropertyModule.PropertyInformationError.ToAddress');
                    var issueSubject = vm.get('Modules.PropertyModule.PropertyInformationError.Subject');
                    var issueBody = vm.get('Modules.PropertyModule.PropertyInformationError.MessageBody');

                    if (visibleLocalityLevel > hdMinLocalityLevel) {

                        a.set({ 'valid': false });
                        a.set({ 'validationMessage': cafm.res.str.MessageVisibleLocalityHigherThanHdMin });
                    }
                    else if (visibleLocalityLevel > engMinLocalityLevel) {
                        a.set({ 'valid': false });
                        a.set({ 'validationMessage': cafm.res.str.MessageVisibleLocalityHigherThanHdMin });
                    }
                    else if (visibleLocalityLevel > contMinLocalityLevel) {
                        a.set({ 'valid': false });
                        a.set({ 'validationMessage': cafm.res.str.MessageVisibleLocalityHigherThanHdMin });
                    }
                    else if (propDataIssueEnabled && ((!issueEmail || !cafm.util.isValidEmail(issueEmail)) || !issueSubject || !issueBody)) {

                        a.set({ 'valid': false });
                        a.set({ 'validationMessage': cafm.res.str.MessageMissingPropertyDataIssueField });
                    }
                    else if (vm.Modules.RoomBooking.CalendarWindowStart >= vm.Modules.RoomBooking.CalendarWindowEnd) {

                        a.set({ 'valid': false });
                        a.set({ 'validationMessage': cafm.res.str.MessageCalendarEndMustBeGreaterThanStart });
                    }
                    else if (cafm.auth.mode == cafm.enums.CAFMAuthenticationMode.Windows && vm.Application.Core.EnableWindowsLogout && !cafm.util.hasStringVal(vm.Application.Core.WindowsLogoutUrl)) {

                        a.set({ 'valid': false });
                        a.set({ 'validationMessage': cafm.res.str.MessageWindowsLogoutUrlMustBeSpecified });
                    }

                    if (vm.get('Modules.Engineer.LeadEngineerRole.CriteriaLastModifiedDateFromDays') > 0 && vm.get('Modules.Engineer.LeadEngineerRole.InactiveJobsLastModifiedDateFrom') &&
                        cafm.util.addDays(cafm.util.truncateToDate(new Date()), vm.get('Modules.Engineer.LeadEngineerRole.CriteriaLastModifiedDateFromDays') * -1) <= cafm.util.ensureDate(vm.get('Modules.Engineer.LeadEngineerRole.InactiveJobsLastModifiedDateFrom'))) {

                        a.set({ 'valid': false });
                        a.set({ 'validationMessage': 'The Engineer Team Leader role \'Inactive Jobs Last Modified Date from filter\' is not valid and must be set to a date prior to today\'s date minus the number of days set for the \'Last Modified Date search filter\'.' });
                    }

                    else if (vm.get('Modules.Engineer.EngineerRole.CriteriaLastModifiedDateFromDays') > 0 && vm.get('Modules.Engineer.EngineerRole.InactiveJobsLastModifiedDateFrom') &&
                        cafm.util.addDays(cafm.util.truncateToDate(new Date()), vm.get('Modules.Engineer.EngineerRole.CriteriaLastModifiedDateFromDays') * -1) <= cafm.util.ensureDate(vm.get('Modules.Engineer.EngineerRole.InactiveJobsLastModifiedDateFrom'))) {

                        a.set({ 'valid': false });
                        a.set({ 'validationMessage': 'The Engineer role \'Inactive Jobs Last Modified Date from filter\' is not valid and must be set to a date prior to today\'s date minus the number of days set for the \'Last Modified Date search filter\'.' });
                    }
                },
                statusCodeFuncs: {
                    200: function (r, s, m) {
                        cafm.msg.showMessageInWindow({
                            title: cafm.res.str.TextConfigSaved,
                            type: cafm.enums.MessageType.Success
                        });
                        cafm.url.set(); // sets current url to base / home path
                    }
                }
            });
        },
        cancel: function () {

            cafm.url.set('SiteConfiguration');
        },
        new: () => {
            cafm.config.configToolbar.save(true);
        },
        migrate: () => {
            cafm.actions.execute({
                url: cafm.url.api('configuration/migrate'),
                values: $('#migrate-container').getViewModel(),
                loaderTarget: body,
                success: () => {
                    cafm.msg.showMessageInWindow({
                        title: cafm.res.str.TextConfigSaved,
                        type: cafm.enums.MessageType.Success
                    });
                    cafm.url.set()
                }
            });
        },
        dump: () => {
            body.showLoader();
            cafm.url.set(cafm.url.api('configuration/dump'));
        },
        recycle: () => {
            body.showLoader();
            cafm.url.set(cafm.url.api('webapp/recycle'));
        }
    },
    sensitiseStatusOptions: function (availId, defId) {

        var avail = $('#' + availId), def = $('#' + defId);

        $(avail).find(':checkbox').each(function (i, elm) {
            var cAv = $(elm);
            var cAvVal = cAv.data('value');
            var cACkd = cAv.prop('checked');
            var cDef = $('input[data-value="' + cAvVal + '"]', def);

            if (cACkd) {
                cDef.setCheckboxDisabled(false);
            } else {

                cDef.setCheckboxDisabled(true);
            }
            cAv.change(function (evt) {
                var chk = $(evt.currentTarget);
                if (chk.prop('checked')) {
                    cDef.setCheckboxDisabled(false);
                }
                else {
                    cDef.setChecked(false);
                    cDef.setCheckboxDisabled(true);
                }
                cDef.trigger('change');
            });
        });
    },
    dataSource: {

        lookupSettingsRead: function () {

            var configVm = cafm.config.viewModel();
            return configVm.Lookups;
        },
        lookupSettingsSave: function (options) {

            var lookup = options.data, configVm = cafm.config.viewModel();

            if (!lookup.Key) {

                options.error();
                return;
            }

            // manually set/ensure these as view model doesn't update from dropdown change events
            var controlTypeDdl = $('[data-container-for="ControlType"] select.cfControl').data('kendoDropDownList'),
                orderDdl = $('[data-container-for="DefaultOrder"] select.cfControl').data('kendoDropDownList'),
                autoBindChk = $('[data-container-for="AutoBind"] input');

            lookup.ControlType = parseInt(controlTypeDdl.value());
            lookup.DefaultOrder = parseInt(orderDdl.value());
            lookup.AutoBind = autoBindChk.prop('checked');

            lookup.KeyDescription = cafm.config.helpers.getLookupKeyDescription(lookup.Key);
            lookup.DefaultOrderDescription = cafm.config.helpers.getLookupDefaultOrderDescription(lookup.DefaultOrder);
            lookup.ControlTypeDescription = cafm.config.helpers.getLookupControlTypeDescription(lookup.ControlType);
            lookup.AutoBindDescription = lookup.AutoBind ? cafm.res.str.TextYes : cafm.res.str.TextNo;

            var existing = cafm.util.find(configVm.Lookups, function (l) {

                return l.Key == lookup.Key;
            });

            if (existing) {

                existing.set(lookup);
            }
            else {

                configVm.Lookups.push(lookup);
            }

            // fire success handler
            options.success(lookup);
        },
        lookupSettingsDelete: function (options) {

            var lookup = options.data, configVm = cafm.config.viewModel();

            cafm.util.removeWhere(configVm.Lookups, function (l) {

                return l.Key == lookup.Key;
            });

            options.success(lookup);
        },
        lookupSettingsModel: {

            id: 'Key',
            fields: {
                Key: { type: 'number', required: true },
                KeyDescription: { type: 'string' },
                AutoBind: { type: 'boolean' },
                AutoBindDescription: { type: 'string' },
                DefaultOrder: { type: 'number', required: true },
                DefaultOrderDescription: { type: 'string' },
                ControlType: { type: 'number', required: true },
                ControlTypeDescription: { type: 'string' }
            }
        },
        dashboard: function () {

            var viewModel = cafm.config.viewModel();

            $("#Dashboard_ShowNewWorkOrderButton").prop("checked", viewModel.ShowNewWorkOrderButton);

            if (viewModel.StandardWorkOrderGroup.StandardWorkOrderGroupEnabled == true) {
                $("li[data-key='StandardWorkOrderGroups']").find(".cafmPbItemRadioButton").prop('checked', true);
            } else {
                $("li[data-key='StandardWorkOrders']").find(".cafmPbItemRadioButton").prop('checked', true);
            }
        },
        shortcut: function () {

            var scuts = cafm.config.viewModel().Shortcuts || [];

            for (var i = 0; i < scuts.length; i++) {
                if (!scuts[i].Order) {
                    scuts[i].Order = i + 1;
                }
            }

            scuts.sort(function (a, b) {

                return a.Order - b.Order;
            });

            return scuts;
        },
        swo: function () {

            var swos = cafm.config.viewModel().StandardWorkOrder.StandardWorkOrders || [];

            for (var i = 0; i < swos.length; i++) {
                if (!swos[i].Order) {
                    swos[i].Order = i + 1;
                }
            }

            swos.sort(function (a, b) {

                return a.Order - b.Order;
            });

            return swos;
        },
        swog: function () {

            var swogs = cafm.config.viewModel().StandardWorkOrderGroup.StandardWorkOrderGroups || [];

            for (var i = 0; i < swogs.length; i++) {
                if (!swogs[i].Order) {
                    swogs[i].Order = i + 1;
                }
            }

            swogs.sort(function (a, b) {

                return a.Order - b.Order;
            });

            return swogs;
        }
    },
    gridEditors: {

        lookupKeyEditor: function (container, options) {

            var isNew = options.model.Key == 0;

            options.dropDownOptions = {
                enabled: isNew,
                autoBind: false,
                optionLabel: cafm.res.str.MessagePleaseSelect,
                required: true,
                validationMessage: cafm.res.str.MessageLookupTypeIsRequired,
                dataSource: {
                    data: cafm.config.helpers.getLookupKeyItems(isNew)
                },
                change: function (args) {

                    var key = parseInt(args.sender.value()),
                        isPersonLookup = cafm.util.exists(cafm.config.lookupSettingsData.personLookupTypeKeys, function (mk) { return key == mk; }),
                        orderDdl = args.sender.element.closest('tr').find('[data-container-for="DefaultOrder"] select.cfControl').data('kendoDropDownList'),
                        controlTypeDdl = args.sender.element.closest('tr').find('[data-container-for="ControlType"] select.cfControl').data('kendoDropDownList'),
                        anyVal = args.sender.element.closest('.k-widget').find('.k-invalid-msg');

                    if (orderDdl) {

                        var v = orderDdl.value();
                        orderDdl.setDataSource(new kendo.data.DataSource({
                            data: isPersonLookup ? cafm.config.lookupSettingsData.personLookupOrderItems : cafm.config.lookupSettingsData.lookupOrderItems
                        }));

                        orderDdl.refresh();
                        orderDdl.value(v);
                    }

                    if (controlTypeDdl && !cafm.util.exists(cafm.config.lookupSettingsData.controlTypeChangeableLookupTypeKeys, function (mk) { return key == mk; })) {

                        controlTypeDdl.value(0);
                        controlTypeDdl.enable(false);
                    }
                    else {
                        controlTypeDdl.enable(true);
                    }

                    anyVal.remove();
                }
            }

            var element = cafm.grids.editors.dropDownEditor(container, options);
            element.getKendoDropDownList().value(options.model.Key)
        },
        lookupDefaultOrderEditor: function (container, options) {

            var isPersonLookup = cafm.util.exists(cafm.config.lookupSettingsData.personLookupTypeKeys, function (mk) { return options.model.Key == mk; });

            options.dropDownOptions = {
                autoBind: false,
                optionLabel: cafm.res.str.MessagePleaseSelect,
                required: true,
                validationMessage: cafm.res.str.MessageLookupOrderIsRequired,
                dataSource: {
                    data: isPersonLookup ? cafm.config.lookupSettingsData.personLookupOrderItems : cafm.config.lookupSettingsData.lookupOrderItems
                }
            }

            var element = cafm.grids.editors.dropDownEditor(container, options);
            element.getKendoDropDownList().value(options.model.DefaultOrder);
        },
        lookupControlTypeEditor: function (container, options) {

            var model = options.model,
                isControlTypeEnabled = cafm.util.exists(cafm.config.lookupSettingsData.controlTypeChangeableLookupTypeKeys, function (mk) { return options.model.Key == mk; });

            options.dropDownOptions = {
                autoBind: false,
                optionLabel: cafm.res.str.MessagePleaseSelect,
                required: true,
                validationMessage: cafm.res.str.MessageLookupOrderIsRequired,
                enable: isControlTypeEnabled,
                dataSource: {
                    data: cafm.config.lookupSettingsData.lookupControlTypeItems
                },
                change: function (args) {

                    var controlType = parseInt(args.sender.value()),
                        orderDdl = args.sender.element.closest('tr').find('[data-container-for="DefaultOrder"] select.cfControl').data('kendoDropDownList'),
                        autoBindChk = args.sender.element.closest('tr').find('[data-container-for="AutoBind"] input'),
                        anyVal = args.sender.element.closest('.k-widget').find('.k-invalid-msg');

                    if (orderDdl) {

                        if (controlType == cafm.enums.LookupControlType.Dropdown) {
                            var descItem = cafm.util.where(cafm.config.lookupSettingsData.lookupOrderItems, function (loi) { return loi.value == cafm.enums.LookupOrder.DescriptionField; });

                            orderDdl.setDataSource(new kendo.data.DataSource({
                                data: descItem
                            }));
                            orderDdl.value(descItem[0].value);
                            orderDdl.enable(false);
                            orderDdl.refresh();
                        }
                        else {
                            var v = orderDdl.value();
                            orderDdl.setDataSource(new kendo.data.DataSource({
                                data: cafm.config.lookupSettingsData.lookupOrderItems
                            }));
                            orderDdl.value(v);
                            orderDdl.enable(true);
                            orderDdl.refresh();
                        }
                    }

                    anyVal.remove();
                }
            }

            var element = cafm.grids.editors.dropDownEditor(container, options);
            element.getKendoDropDownList().value(options.model.ControlType);
        }
    },
    handlers: {

        lookupSettings: {

            formContainer: null,

            init: function (data) {

                data.allLookupOrderItems = [];
                cafm.util.addAll(data.allLookupOrderItems, data.lookupOrderItems);
                cafm.util.addAll(data.allLookupOrderItems, data.personLookupOrderItems);
                cafm.config.lookupSettingsData = data;
            },
            gridEdit: function (args) {

                if (args.model.ControlType == cafm.enums.LookupControlType.Dropdown) {

                    args.container.find('[data-container-for="DefaultOrder"] select.cfControl').data('kendoDropDownList').enable(false);
                }
            },
            load: function () {

                var me = this;

                var configVm = cafm.config.viewModel();

                if (configVm && !cafm.util.hasItem(configVm.Lookups)) {

                    setTimeout(function () { $('#lookupSettingsForm .k-grid-add').click(); }, 250);
                }
            }
        },
        shortcut: {
            add: function () {
                cafm.views.openActionWindow({
                    url: cafm.url.get('siteconfiguration/newshortcut'),
                    viewModel: {
                        ID: cafm.guid.newGuid(),
                        _isNew: true,
                        Image: {},
                        Order: cafm.config.dataSource.shortcut().length + 1
                    }
                })
            },
            dataBound: function (args) {

                cafm.config.helpers.shortcutAndSwoDragOrderSetup(args, 'shortcut');
            },
            edit: function (dataItem) {

                var bind = dataItem.toJSON();
                bind.Target = bind.Target === '_blank';

                cafm.views.openActionWindow({
                    url: cafm.url.get('siteconfiguration/editshortcut/{0}', dataItem.ID),
                    viewModel: bind
                })
            },
            save: function () {

                var form = $('#shortcutForm');
                form.find('#URL').attr('data-url-msg', cafm.res.str.MessageUrlIsNotValid);
                if (form.validateElement()) {

                    let ds = cafm.config.dataSource.shortcut();
                    let updated = cafm.views.getActionWindowViewModel();
                    let upload = cafm.fu.getFileUpload($('#shortcutImageUpload').data('id')),
                        hasUpload = upload.filename && upload.ext;

                    if (hasUpload && upload.status == cafm.enums.FileUploadProgress.InProgress) return;

                    let persist;
                    updated.Target = updated.Target === true ? '_blank' : '_self';

                    if (!updated._isNew) {

                        persist = cafm.util.find(ds, function (s) { return s.ID == updated.ID });

                        if (persist) {

                            persist.set(updated.toJSON());
                            cafm.util.removeWhere(ds, function (s) { return s.ID == updated.ID });
                        }
                    }
                    else {

                        persist = updated;
                    }

                    if (hasUpload && upload.status == cafm.enums.FileUploadProgress.Complete) {

                        if (persist.Image) persist.Image = {};
                        persist.Image.FileUploadID = upload.uploadId;
                        persist.Image.FileName = upload.filename;
                        persist.Image.FileURL = cafm.url.get('temp/{0}{1}'.format(upload.uploadId, upload.ext));
                    }

                    if (persist.PermittedRoleTypes) {

                        if (cafm.util.hasItem(persist.PermittedRoleTypes)) {

                            var items = cafm.views.getActionForm().find('#PermittedRoleTypes').getKendoMultiSelect().dataSource.data();

                            persist.PermittedRoleTypesDescription = cafm.util.transformArray(cafm.util.where(items, function (rt) { return persist.PermittedRoleTypes.indexOf(rt.value) > -1; }), function (rt) {
                                return isObj(rt) ? rt.text : rt;
                            }).join(', ');
                        }
                        else {

                            persist.PermittedRoleTypesDescription = null;
                        }
                    }

                    delete persist._isNew;
                    ds.push(persist);
                    $('#shortcutGrid').refreshGridDataSource();
                    cafm.views.closeActionWindow();
                }
            },
            cancel: function (e) {

                cafm.toolbar.standardActionToolbar.cancel(e);
            },
            delete: function (dataItem) {

                var ds = cafm.config.dataSource.shortcut();
                cafm.util.removeWhere(ds, function (s) {
                    return s.ID == dataItem.ID;
                });
                cafm.config.helpers.reindexOrderedArray(ds);
                $('#shortcutGrid').refreshGridDataSource();
            }
        },
        swo: {
            add: function () {
                cafm.views.openActionWindow({
                    url: cafm.url.get('siteconfiguration/newstandardworkorder'),
                    viewModel: {
                        ID: cafm.guid.newGuid(),
                        _isNew: true,
                        Image: {},
                        Order: cafm.config.dataSource.swo().length + 1
                    }
                })
            },
            dataBound: function (args) {

                cafm.config.helpers.shortcutAndSwoDragOrderSetup(args, 'swo');
            },
            edit: function (dataItem) {

                var bind = dataItem.toJSON();
                bind.Target = bind.Target === '_blank';
                if (!bind.Image) bind.Image = {};

                cafm.views.openActionWindow({
                    url: cafm.url.get('siteconfiguration/editstandardworkorder/{0}', dataItem.ID),
                    viewModel: bind
                })
            },
            save: function () {

                var form = $('#swoForm');

                if (form.validateElement()) {

                    let ds = cafm.config.dataSource.swo();
                    let updated = cafm.views.getActionWindowViewModel();
                    let upload = cafm.fu.getFileUpload($('#swoImageUpload').data('id')),
                        hasUpload = upload.filename && upload.ext;

                    if (hasUpload && upload.status == cafm.enums.FileUploadProgress.InProgress) return;

                    let persist;
                    updated.Target = updated.Target === true ? '_blank' : '_self';

                    if (!updated._isNew) {

                        persist = cafm.util.find(ds, function (s) { return s.ID == updated.ID });

                        if (persist) {

                            persist.set(updated.toJSON());
                            cafm.util.removeWhere(ds, function (s) { return s.ID == updated.ID });
                        }
                    }
                    else {

                        persist = updated;
                    }

                    var swoDropdown = form.find('[name=StandardWorkOrderDescription]').getKendoDropDownList();
                    if (swoDropdown) {
                        persist.StandardWorkOrderID = swoDropdown.value();
                        persist.StandardWorkOrderDescription = swoDropdown.text();
                    }

                    if (hasUpload && upload.status == cafm.enums.FileUploadProgress.Complete) {

                        if (persist.Image) persist.Image = {};
                        persist.Image.FileUploadID = upload.uploadId;
                        persist.Image.FileName = upload.filename;
                        persist.Image.FileURL = cafm.url.get('temp/{0}{1}'.format(upload.uploadId, upload.ext));
                    }

                    if (persist.PermittedRoleTypes) {

                        if (cafm.util.hasItem(persist.PermittedRoleTypes)) {

                            var items = cafm.views.getActionForm().find('#PermittedRoleTypes').getKendoMultiSelect().dataSource.data();

                            persist.PermittedRoleTypesDescription = cafm.util.transformArray(cafm.util.where(items, function (rt) { return persist.PermittedRoleTypes.indexOf(rt.value) > -1; }), function (rt) {
                                return isObj(rt) ? rt.text : rt;
                            }).join(', ');
                        }
                        else {

                            persist.PermittedRoleTypesDescription = null;
                        }
                    }

                    delete persist._isNew;
                    ds.push(persist);
                    $('#swoGrid').refreshGridDataSource();
                    cafm.views.closeActionWindow();
                }
            },
            cancel: function (e) {

                cafm.toolbar.standardActionToolbar.cancel(e);
            },
            delete: function (dataItem) {

                var ds = cafm.config.dataSource.swo();
                cafm.util.removeWhere(ds, function (s) {
                    return s.ID == dataItem.ID;
                });
                cafm.config.helpers.reindexOrderedArray(ds);
                $('#swoGrid').refreshGridDataSource();
            }
        },
        swog: {
            add: function () {
                cafm.views.openActionWindow({
                    url: cafm.url.get('siteconfiguration/newstandardworkordergroup'),
                    viewModel: {
                        ID: cafm.guid.newGuid(),
                        _isNew: true,
                        Image: {},
                        Order: cafm.config.dataSource.swog().length + 1
                    }
                })
            },
            dataBound: function (args) {

                cafm.config.helpers.shortcutAndSwoDragOrderSetup(args, 'swog');
            },
            edit: function (dataItem) {

                var bind = dataItem.toJSON();
                bind.Target = bind.Target === '_blank';
                if (!bind.Image) bind.Image = {};

                cafm.views.openActionWindow({
                    url: cafm.url.get('siteconfiguration/editstandardworkordergroup/{0}', dataItem.ID),
                    viewModel: bind
                })
            },
            save: function () {

                var form = $('#swogForm');

                if (form.validateElement()) {

                    let ds = cafm.config.dataSource.swog();
                    let updated = cafm.views.getActionWindowViewModel();
                    let upload = cafm.fu.getFileUpload($('#swogImageUpload').data('id')),
                        hasUpload = upload.filename && upload.ext;

                    if (hasUpload && upload.status == cafm.enums.FileUploadProgress.InProgress) return;

                    let persist;
                    updated.Target = updated.Target === true ? '_blank' : '_self';

                    if (!updated._isNew) {

                        persist = cafm.util.find(ds, function (s) { return s.ID == updated.ID });

                        if (persist) {

                            persist.set(updated.toJSON());
                            cafm.util.removeWhere(ds, function (s) { return s.ID == updated.ID });
                        }
                    }
                    else {

                        persist = updated;
                    }

                    var swogDropdown = form.find('[name=StandardWorkOrderGroupDescription]').getKendoDropDownList();
                    if (swogDropdown) {
                        persist.StandardWorkOrderGroupID = swogDropdown.value();
                        persist.StandardWorkOrderGroupDescription = swogDropdown.text();
                    }

                    if (hasUpload && upload.status == cafm.enums.FileUploadProgress.Complete) {

                        if (persist.Image) persist.Image = {};
                        persist.Image.FileUploadID = upload.uploadId;
                        persist.Image.FileName = upload.filename;
                        persist.Image.FileURL = cafm.url.get('temp/{0}{1}'.format(upload.uploadId, upload.ext));
                    }

                    if (persist.PermittedRoleTypes) {

                        if (cafm.util.hasItem(persist.PermittedRoleTypes)) {

                            var items = cafm.views.getActionForm().find('#PermittedRoleTypes').getKendoMultiSelect().dataSource.data();

                            persist.PermittedRoleTypesDescription = cafm.util.transformArray(cafm.util.where(items, function (rt) { return persist.PermittedRoleTypes.indexOf(rt.value) > -1; }), function (rt) {
                                return isObj(rt) ? rt.text : rt;
                            }).join(', ');
                        }
                        else {

                            persist.PermittedRoleTypesDescription = null;
                        }
                    }

                    delete persist._isNew;
                    ds.push(persist);
                    $('#swogGrid').refreshGridDataSource();
                    cafm.views.closeActionWindow();
                }
            },
            cancel: function (e) {

                cafm.toolbar.standardActionToolbar.cancel(e);
            },
            delete: function (dataItem) {

                var ds = cafm.config.dataSource.swog();
                cafm.util.removeWhere(ds, function (s) {
                    return s.ID == dataItem.ID;
                });
                cafm.config.helpers.reindexOrderedArray(ds);
                $('#swogGrid').refreshGridDataSource();
            }
        },
        click: function () {

            $(".cafmPb").on("click", ".cafmPbItem", function (e) {
                e.stopPropagation();
            });
        },
        radioButtonChange: function (el) {

            var checked = $(el).is(":checked");
            var type = $(el).closest("li").attr("data-key");

            if (type == "StandardWorkOrders") {
                cafm.config.viewModel().StandardWorkOrder.StandardWorkOrderEnabled = checked;
                cafm.config.viewModel().StandardWorkOrderGroup.StandardWorkOrderGroupEnabled = !checked;
            } else if (type == "StandardWorkOrderGroups") {
                cafm.config.viewModel().StandardWorkOrderGroup.StandardWorkOrderGroupEnabled = checked;
                cafm.config.viewModel().StandardWorkOrder.StandardWorkOrderEnabled = !checked;
            }
        },
        checkboxChange: function (checked) {
            
            cafm.config.viewModel().ShowNewWorkOrderButton = checked;
        }
    },
    helpers: {

        getLookupKeyItems: function (excludeExisting) {

            if (excludeExisting) {

                var existingKeys = cafm.util.transformArray(cafm.config.viewModel().Lookups, function (l) {

                    return '' + l.Key;
                });

                return cafm.util.where(cafm.config.lookupSettingsData.lookupKeyItems, function (l) {

                    return existingKeys.indexOf(l.value) == -1;
                });
            }
            else {

                return cafm.config.lookupSettingsData.lookupKeyItems;
            }
        },
        getLookupOrderItems: function () {

            return cafm.config.lookupSettingsData.lookupOrderItems;
        },
        getPersonLookupOrderItems: function () {

            return cafm.config.lookupSettingsData.personLookupOrderItems;
        },
        getLookupKeyDescription: function (lookupKey) {

            var item = cafm.util.find(cafm.config.lookupSettingsData.lookupKeyItems, function (l) {

                return l.value == lookupKey;
            });

            return item ? item.text : '';
        },
        getLookupDefaultOrderDescription: function (lookupDefaultOrder) {

            var item = cafm.util.find(cafm.config.lookupSettingsData.allLookupOrderItems, function (l) {

                return l.value == lookupDefaultOrder;
            });

            return item ? item.text : '';
        },
        getLookupControlTypeDescription: function (lookupControlType) {

            var item = cafm.util.find(cafm.config.lookupSettingsData.lookupControlTypeItems, function (l) {

                return l.value == lookupControlType;
            });

            return item ? item.text : '';
        },
        reindexOrderedArray: function (arr) {

            if (cafm.util.hasItem(arr)) {

                arr.sort(function (a, b) {

                    return a.Order - b.Order;
                });

                for (var i = 0; i < arr.length; i++) {
                    arr[i].Order = i + 1;
                }
            }
        },
        shortcutAndSwoDragOrderSetup: function (args, key) {

            var grid = args.sender, dataSource = grid.dataSource;

            grid.table.kendoDraggable({
                filter: "tbody > tr",
                group: "gridGroup",
                hint: function (e) {
                    return $('<div class="k-grid k-widget"><table><tbody><tr>' + e.html() + '</tr></tbody></table></div>');
                }
            });

            grid.table.kendoDropTargetArea({
                group: "gridGroup",
                filter: 'tbody > tr',
                drop: function (e) {

                    var target = dataSource.getByUid($(e.draggable.currentTarget).data("uid")),
                        dest = e.dropTarget;

                    dest = dataSource.getByUid(dest.data("uid"));

                    //not on same item
                    if (target.get("ID") !== dest.get("ID")) {

                        var items = cafm.config.dataSource[key](), activeRenumbering = false;
                        var targ = cafm.util.find(items, function (s) { return s.ID == target.ID });
                        var dest = cafm.util.find(items, function (s) { return s.ID == dest.ID });

                        cafm.util.arrayMove(items, targ.Order - 1, dest.Order - 1);

                        for (var i = 0; i < items.length; i++) {
                            items[i].Order = i + 1;
                        }

                        cafm.config.helpers.reindexOrderedArray(items);
                        $('#{0}Grid'.format(key)).refreshGridDataSource();
                    }
                }
            });
        }
    },
    reports: {
        _dataSource: null,
        dataSource: function () {

            if (cafm.config.reports._dataSource === null) {

                var flattened = cafm.util.addAll([], cafm.config.reports.data);

                cafm.config.reports.data.forEach(function (item) {

                    var addReps = function (reps) {

                        if (cafm.util.hasItem(reps)) {

                            cafm.util.addAll(flattened, reps);
                        }
                    }

                    if (item.ChildGroups && cafm.util.hasItem(item.ChildGroups.Items)) {

                        cafm.util.addAll(flattened, item.ChildGroups.Items);

                        item.ChildGroups.Items.forEach(function (subGroup) {

                            addReps(subGroup.Reports);
                        })
                    }

                    addReps(item.Reports);
                });

                cafm.config.reports._dataSource = new kendo.data.TreeListDataSource({
                    transport: {
                        read: function (options) {
                            options.success(flattened);
                        }
                    },
                    schema: {
                        model: {
                            id: 'ID',
                            parentId: 'ParentID',
                            fields: {
                                ParentID: { field: 'ParentID', type: 'string', nullable: true },
                                ID: { field: 'ID', type: 'string' }
                            },
                            expanded: true
                        }
                    }
                });
            }

            return cafm.config.reports._dataSource;
        },
        panelSelected: function (args) {

            var item = $(args.item)
            if (!item.data('treeRendered')) {

                cafm.config.reports.setupReportTreeList(item.find('.report-tree-list'));
                item.data('treeRendered', true);
            }
        },
        setRoleData: function (targetRoleName, targetRoleObj) {

            var treeList = $('#reportRoles_{0} .k-grid'.format(targetRoleName)).getKendoTreeList();
            if (!treeList) return;

            var reportIds = [];
            $('#reportRoles_{0} tr[data-selected]'.format(targetRoleName)).each(function (i, el) {

                var row = $(el);
                reportIds.push(treeList.dataItem(row).ID);
            })
            targetRoleObj.PermittedReportIDs = reportIds;
        },
        setupReportTreeList: function (element) {

            var selected = cafm.config.viewModel().get(element.data('field'));

            element.kendoTreeList({
                dataSource: cafm.config.reports.dataSource(),
                height: 400,
                columns: [
                    {
                        field: 'Description', title: '', expandable: false, template: function (data) {

                            return data.Title || ('{0}{1}'.format(data.Description, data.MajorGroupID === cafm.config.reports.customReportsMajorGroupId ? ' (custom)' : ''));
                        }
                    }
                ],
                dataBound: function (args) {

                    if (cafm.util.hasItem(selected)) {

                        selected.forEach(function (repId) {

                            var report = args.sender.dataSource.get(repId);
                            if (report)
                                args.sender.element.find('tr[data-uid={0}]'.format(report.uid)).attr('data-selected', true);
                        })
                    }

                    args.sender.element.find('.k-treelist-group').each(function (i, groupEl) {

                        groupEl = $(groupEl);
                        if (!groupEl.find('[type="checkbox"]').length && !groupEl.next().hasClass('k-treelist-group')) {

                            var checked = !groupEl.nextUntil('.k-treelist-group').filter(':not([data-selected])').length, guid = cafm.guid.newGuid();
                            groupEl.find('td').prepend('<label class="k-checkbox-label" for="{0}"></label>'.format(guid)).prepend('<input type="checkbox" class="k-checkbox" id="{0}"{1}/>'.format(guid, checked ? ' checked' : ''));
                        }
                    });

                    setTimeout(function () {
                        args.sender.element.off('click.cafm').on('click.cafm', '.k-checkbox-label', function (e) {

                            var chk = $(e.currentTarget).siblings('[type=checkbox]');
                            chk.toggleCheckbox();
                            if (chk.isChecked())
                                chk.closest('tr').nextUntil('.k-treelist-group').attr('data-selected', true);
                            else
                                chk.closest('tr').nextUntil('.k-treelist-group').removeAttr('data-selected');
                        });
                    }, 500)
                }
            }).on('click', '.k-grid-content tr > td', function (e) {

                var jel = $(e.currentTarget).closest('tr');

                if (jel.hasClass('k-treelist-group')) {

                    e.preventDefault();
                }
                else if (jel.attr('data-selected')) {

                    jel.removeAttr('data-selected');
                    jel.prevAll('.k-treelist-group:first').find('.chk').setChecked(false, true);
                    e.preventDefault();
                }
                else {

                    jel.attr('data-selected', true);
                    if (!jel.prevAll('.k-treelist-group:first').nextUntil('.k-treelist-group').filter(':not([data-selected])').length)
                        jel.prevAll('.k-treelist-group:first').find('.chk').setChecked(true, true);

                    e.preventDefault();
                }
            });
        }
    }
}